export class ParticipantSetting {
    id: number;
    user_id: number;
    event_id: number;
    smtp_host: string;
    smtp_port: number;
    smtp_username: string;
    smtp_password: string;
    smtp_encryption: string;
    smtp_from_name: string;
    smtp_from_address: string;
    smtp_is_valid = false;
    notify_keywords_interval: string;
    notify_matching_interval: string;
    notify_interest_interval: string;
    notify_messaging_interval: string;
    notify_chat_group_interval: string;
    notify_keywords_interval_push: string;
    notify_matching_interval_push: string;
    notify_interest_interval_push: string;
    notify_messaging_interval_push: string;
    notify_chat_group_interval_push: string;
    locale: string;
    is_global = false;

    set_global = false;
    sendTestMail = false;
    possibleIntervals = [
        'immediately',
        'hourly',
        'in the morning',
        'noon',
        'noon and evenings',
        'evenings',
        'once a week',
        'twice a week',
        'once a month',
        'twice a month',
        'never',
    ];

    /**
     * constructor
     *
     * @param {ParticipantSetting} init
     */
    public constructor(init?: ParticipantSetting)
    {
        if (!!init)
        {
            Object.assign(this, init);
        }
    }
}
